

















































































import { Vue, Prop, p, Lifecycle, Component, Watch } from "av-ts";

import { ITopic, IUser } from "../../interfaces/models";

import Fetcher from "../../services/Fetcher";
import UserService from "../../services/UserService";

interface IRenderWeight {
    [mentorType: string]: {
        [topicId: string]: number
    }
}

@Component()
export default class ConnectednessHeatmap extends Vue {
    @Prop topics = p<ITopic[]>({
        required: true
    });
    @Prop categories = p<string[]>({
        required: true
    });

    renderWeights: IRenderWeight = {};
    pConnections: IUser[] = [];

    updateConnections(newConnections: IUser[]) {
        this.pConnections = newConnections;
    }

    get connections() {
        return this.pConnections;
    };

    renderColor(category: string, topicId: number) {
        const max = 1;
        const weight = (this.renderWeights[category] && this.renderWeights[category][topicId]) || 0;
        return {
            background: `rgba(34, 85, 102, ${weight / max})`
        };
    }

    updatedCategories() {
        this.categories.forEach(category => {
            this.topics.forEach(topic => {
                if (this.renderWeights[category] === undefined) {
                    this.renderWeights[category] = {};
                }
                this.renderWeights[category][topic.id] = Math.random();
            });
        });
    }

    @Watch("categories")
    changeCategories(_newValue: string[], _oldValue: string[]) {
        this.updatedCategories();
    }

    @Lifecycle
    created() {
        Fetcher.get(UserService.getUserPeers, { count: 10 })
            .on(this.updateConnections);
        this.updatedCategories();
    }

    @Lifecycle
    destroyed() {
        Fetcher.get(UserService.getUserPeers, { count: 10 })
            .off(this.updateConnections);
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/util/ConnectednessHeatmap.vue